import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";

export class AudioButtonsContainer extends Phaser.Group {

    public static MUSIC_ON = "music_on";
    public static MUSIC_OFF = "music_off";
    public static EFFECTS_ON = "effects_on";
    public static EFFECTS_OFF = "effects_off";

    private musicOnButton: Phaser.Button;
    private musicOffButton: Phaser.Button;
    private fxOnButton: Phaser.Button;
    private fxOffButton: Phaser.Button;

    constructor(game: Phaser.Game, musicButtonPosition: Phaser.Point, fxButtonPosition: Phaser.Point) {

        super(game, null, "audio buttons", false);

        this.musicOnButton = new Phaser.Button(this.game, musicButtonPosition.x, musicButtonPosition.y, "texture_atlas_5", this.onClickMusicOn, this, "music_on_button_on", "music_on_button_off", "music_on_button_on");
        this.add(this.musicOnButton);

        this.musicOffButton = new Phaser.Button(this.game, musicButtonPosition.x, musicButtonPosition.y, "texture_atlas_5", this.onClickMusicOff, this, "music_off_button_on", "music_off_button_off", "music_off_button_on");
        this.add(this.musicOffButton);

        if (AudioManager.getInstance().isMusicMuted) {
            this.musicOnButton.visible = false;
        } else {
            this.musicOffButton.visible = false;
        }

        // fx
        this.fxOnButton = new Phaser.Button(this.game, fxButtonPosition.x, fxButtonPosition.y, "texture_atlas_5", this.onClickFxOn, this, "fx_button_on_on", "fx_button_on_off", "fx_button_on_on");
        this.add(this.fxOnButton);

        this.fxOffButton = new Phaser.Button(this.game, fxButtonPosition.x, fxButtonPosition.y, "texture_atlas_5", this.onClickFxOff, this, "fx_button_off_on", "fx_button_off_off", "fx_button_off_on");
        this.add(this.fxOffButton);

        if (AudioManager.getInstance().areEffectsMuted) {
            this.fxOnButton.visible = false;
        } else {
            this.fxOffButton.visible = false;
        }

        AudioManager.getInstance().musicOnButton = this.musicOnButton;
        AudioManager.getInstance().musicOffButton = this.musicOffButton;
        AudioManager.getInstance().fxOnButton = this.fxOnButton;
        AudioManager.getInstance().fxOffButton = this.fxOffButton;
    }

    private onClickMusicOn(): void {

        this.musicOnButton.visible = false;
        this.musicOffButton.visible = true;

        GameManager.changeAudioPreferences(AudioButtonsContainer.MUSIC_ON);
    }

    private onClickMusicOff(): void {

        this.musicOnButton.visible = true;
        this.musicOffButton.visible = false;

        GameManager.changeAudioPreferences(AudioButtonsContainer.MUSIC_OFF);
    }

    private onClickFxOn(): void {

        this.fxOnButton.visible = false;
        this.fxOffButton.visible = true;

        GameManager.changeAudioPreferences(AudioButtonsContainer.EFFECTS_ON);
    }

    private onClickFxOff(): void {

        this.fxOnButton.visible = true;
        this.fxOffButton.visible = false;

        GameManager.changeAudioPreferences(AudioButtonsContainer.EFFECTS_OFF);
    }
}
